import styled from 'styled-components';
import { Typography } from '@mui/material';

import { colors } from '../../theme';

interface MessageProps {
    isError?: boolean;
    isSuccess?: boolean;
}

const ToastMessage = (props: any) => {
    const { msg, isEntireMsg, icon } = props;
    return (
        <ErrorMsg {...props}>
            {icon}
            <span>{msg}</span>
        </ErrorMsg>
    );
};

export default ToastMessage;

const ErrorMsg = styled(Typography)<MessageProps>`
    && {
        padding: 5px;
        border-radius: 0px 5px 5px 0px;
        margin-bottom: 1em;
        font-size: 14px;
        display: flex;
        align-items: center;
        color: ${colors.blue.main};
        background-color: ${colors.blue.light};
        border-left: 4px solid ${colors.blue.main};
        svg {
            margin-right: 5px;
            width: 20px;
            height: auto;
            path {
                fill: ${colors.blue.main};
            }
        }

        span {
            display: flex;
            align-items: center;
        }

        ${(props) =>
            props.isError && {
                color: colors.red.main,
                backgroundColor: colors.red.light,
                borderColor: colors.red.main,
                svg: {
                    path: {
                        fill: colors.red.main,
                    },
                },
            }}

        ${(props) =>
            props.isSuccess && {
                color: colors.green.main,
                backgroundColor: colors.green.light,
                borderColor: colors.green.main,
                svg: {
                    path: {
                        fill: colors.green.main,
                    },
                },
            }}
    }
`;
